module.exports = __webpack_public_path__ + "img/seniority_bg.22b438ee.png";